import React from "react";
import { useNavigate } from "react-router-dom";
import { ACCENT } from "./shared";

// "Before you can withdraw": every item the server says is still missing, by name, with a button to where it is fixed
// (wallet.withdrawal.missing_items from GET /v1/artist-wallet). Items marked `waiting` are with Pipaan or Stripe or on a timed hold,
// so they have no button. Nothing is shown when there is nothing missing.

const ACTION_LABELS = {
  tax_form: "Send tax form",
  application: "Fix application",
  payout_method: "Add payout method",
  stripe_onboarding: "Continue with Stripe",
};

const PATHS = {
  tax_form: "/artist-studio/wallet/tax",
  application: "/artist-studio/verification",
  payout_method: "/artist-studio/wallet/payout-method",
  stripe_onboarding: "/artist-studio/wallet/payout-method",
};

export default function MissingItems({ items }) {
  const navigate = useNavigate();
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <section className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4" aria-label="Before you can withdraw" data-testid="missing-items">
      <h2 className="text-[16px] font-bold text-gray-900">Before you can withdraw</h2>
      <ul className="mt-2 divide-y divide-amber-100">
        {items.map((item) => {
          const path = item.action ? PATHS[item.action] : null;
          return (
            <li key={item.key} className="flex flex-wrap items-center justify-between gap-3 py-2.5" data-testid="missing-item">
              <div className="min-w-0">
                <p className="text-[15px] font-semibold text-gray-900">
                  {item.label}
                  {item.kind === "waiting" && (
                    <span className="ml-2 rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-gray-600" data-testid="missing-item-waiting">In progress</span>
                  )}
                </p>
                {item.detail && <p className="text-[13px] text-gray-600">{item.detail}</p>}
              </div>
              {path && (
                <button
                  type="button" onClick={() => navigate(path)} className="shrink-0 text-[14px] font-semibold underline" style={{ color: ACCENT }}
                  data-testid="missing-item-action"
                >
                  {ACTION_LABELS[item.action] || "Fix"}
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
